// extracted by mini-css-extract-plugin
export var dividerLine = "_8c-3";
export var itemImage = "_8c-9";
export var lightDivider = "_8c-4";
export var modalContent = "_8c-5";
export var modalContentCompact = "_8c-6";
export var productCard = "_8c-a";
export var productImage = "_8c-b";
export var productImageCompact = "_8c-7";
export var productImagePlaceholder = "_8c-c";
export var productImagePlaceholderCompact = "_8c-8";
export var progressBarBackground = "_8c-1";
export var progressBarContainer = "_8c-0";
export var progressBarFill = "_8c-2";